import { render, staticRenderFns } from "./organ.vue?vue&type=template&id=da41e76e&scoped=true&"
import script from "./organ.vue?vue&type=script&lang=js&"
export * from "./organ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da41e76e",
  null
  
)

export default component.exports